import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiPostRequest,
  apiGetByIdRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { kmMessages } from "src/constant/Messages";
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const VotingForm = ({ enableGlobalLoader, disableGlobalLoader, displaySnackbar, setLogoutUser, ...rest }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();
  const [voting, setVoting] = useState();

  let pageTitle = "Głosowanie";

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(apiEndpoints.getVotingAdminDetails.path, entryId, true)
      .then((data) => {
        disableGlobalLoader();
        setVoting(data);
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, []);

  const onSubmit = (votingId,votingOptionId,userId) => {

    if (votingOptionId){
      enableGlobalLoader();

      apiPostRequest(
        apiEndpoints.storeAdminVoteForUser.path,
        {
          votingId: votingId,
          votingOptionId: votingOptionId,
          userId: userId
        },
        true
      )
        .then((data) => {
          disableGlobalLoader();
          navigate(`/zarzadzanieglosowania/podgladglosowania/${entryId}`);
        })
        .catch((error) => {
          disableGlobalLoader();
          if (error.response && error.response.status === 401) {
            setLogoutUser();
          }
        });
   
    } else {
      displaySnackbar({
        isOpen: true,
        severity: "error",
        autoHideDuration: 5000,
        message: kmMessages.error.voting.voteoption_notselected,
      });
    }
  };
    

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
        {pageTitle}
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form onSubmit={onSubmit} voting={voting} entryId={entryId} />
        </Box>
      </Container>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
    setLogoutUser: () => dispatch(actions.setLogoutUser())
});

export default connect(null, mapDispatchToProps)(VotingForm);
